import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/data";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="section-y bg-gradient-to-b from-white to-accent/30">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div className="max-w-2xl">
            <p className="overline mb-3">Nos services</p>
            <h2 className="text-3xl sm:text-4xl font-semibold text-secondary tracking-tight">
              Des solutions complètes pour toutes vos surfaces extérieures.
            </h2>
          </div>
          <p className="text-muted-foreground max-w-md">
            Choisissez le service qui correspond à votre besoin.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {SERVICES.map((s) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className="card-elevated overflow-hidden group"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={s.imagePosition ? { objectPosition: s.imagePosition } : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-secondary mb-2">{s.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed mb-5">{s.desc}</p>
                <Button
                  asChild
                  data-testid={`service-book-${s.id}`}
                  variant="ghost"
                  className="text-primary hover:text-primary hover:bg-accent px-0 group/btn"
                >
                  <a href="#reservation">
                    Réserver
                    <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                  </a>
                </Button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
